import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { env } from '@/env'
import { forbiddenErrorComponent, requirePermission } from '@/lib/routeGuards'

export const Route = createFileRoute('/_app/lens')({
  component: () => <Outlet />,
  beforeLoad: ({ context }) => {
    if (!env.VITE_NOTEBOOK_ANALYSIS_ENABLED) {
      throw redirect({ to: '/library' })
    }
    requirePermission(context.permissions, 'read:audit_logs')
  },
  errorComponent: forbiddenErrorComponent,
})
